<template>
  <div>
    <img src="@/assets/images/EnglishRegisterPage.jpg" alt="">
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: 'EnglishRegister',
  data() {
    return {}
  },
  computed: {
    authCode() {
      return this.$route.query.authCode;
    }
  },
  created() {
    this.$toast.loading({
      message: 'loading',
      forbidClick: true,
      loadingType: 'spinner',
      duration: 0
    });
    if(this.authCode) {
      this.$axios.post('/Api/Api/Web/Customer/GetENUser', {
        code: this.authCode,
        uinonid: sessionStorage.getItem("AuthInfo") ? JSON.parse(sessionStorage.getItem("AuthInfo")).Unionid : ''
      }).then(res => {
        this.$toast.clear();
        if (res.RetCode == '10000') {
          sessionStorage.setItem("userInfo", JSON.stringify(res.Data));
          this.setUserInfo({userInfo: res.Data});
          this.$router.replace('/home');
        } else {
          this.$toast(res.RetMsg);
        }
      })
    } else {
      // window.location.href = 'https://dmall.jjmc.cn/ciam/english-login?appId=7168201071593063';
      window.location.href = process.env.VUE_APP_CIM_URL;
    }
  },
  methods: {
    ...mapActions(['setUserInfo'])
  }
}
</script>

<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  height: 100%;
}
</style>